import { useCallback, useRef } from 'react'
import { useEvent, useIsomorphicLayoutEffect } from 'react-use'
import localFont from 'next/font/local'
import { JetBrains_Mono } from 'next/font/google'

const dinNextLtPro = localFont({
  src: [
    {
      path: './fonts/DINNextLTPro-Light.woff2',
      weight: '300',
      style: 'normal'
    },
    {
      path: './fonts/DINNextLTPro-Regular.woff2',
      weight: '400',
      style: 'normal'
    }
  ]
})

const dinNextLtProCondensed = localFont({
  src: [
    {
      path: './fonts/DINNextLTPro-Condensed.woff2',
      weight: '400',
      style: 'normal'
    }
  ]
})

const jetBrainsMono = JetBrains_Mono({
  subsets: ['latin'],
  weight: ['400']
})

export type ThemeProps = Partial<{
  theme: 'dark' | 'light'
}>

const Theme = ({}: ThemeProps) => {
  const lastViewportWidth = useRef(0)

  const resize = useCallback(() => {
    const viewportWidth = window.innerWidth
    const viewportHeight = window.innerHeight

    if (lastViewportWidth.current === viewportWidth) return
    lastViewportWidth.current = viewportWidth

    const vh = (viewportHeight * 0.01).toFixed(2)
    document.documentElement.style.setProperty('--vh', `${vh}px`)
  }, [])

  useIsomorphicLayoutEffect(() => resize(), [resize])

  useEvent('resize', resize)

  return (
    <style jsx global>{`
      :root {
        --font-family-base: ${dinNextLtPro.style.fontFamily};
        --font-family-condensed: ${dinNextLtProCondensed.style.fontFamily};
        --font-family-mono: ${jetBrainsMono.style.fontFamily};
        --header-height: 4.7rem;

        --font-size: 10px;
      }

      @media (min-width: 768px) {
        :root {
        }
      }
    `}</style>
  )
}

export default Theme
